import { NgClass } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";

import { SkeletonModule } from "primeng/skeleton";

import { CategoryItemIcon } from "@shared/models";

@Component({
  selector: "app-category-item",
  standalone: true,
  imports: [NgClass, SkeletonModule],
  templateUrl: "./category-item.component.html",
  styleUrl: "./category-item.component.scss",
})
export class CategoryItemComponent {
  @Input() icon: CategoryItemIcon | undefined = undefined;
  @Input() label: string | null = null;
  @Input() underlined: boolean = false;
  @Input() value: string | undefined = undefined;
  @Input() isLoading: boolean = false;
}
